/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for qsClassifierType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="qsClassifierType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="querySubject"/&gt; &lt;enumeration value="operationQuerySubject"/&gt; &lt;enumeration value="joinQuerySubject"/&gt; &lt;enumeration value="sqlQuerySubject"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class QsClassifierType extends Enum{

	enumValue = null;

	static  QUERY_SUBJECT = QsClassifierType.newLiteral("querySubject");

	static  OPERATION_QUERY_SUBJECT = QsClassifierType.newLiteral("operationQuerySubject");

	static  JOIN_QUERY_SUBJECT = QsClassifierType.newLiteral("joinQuerySubject");

	static  SQL_QUERY_SUBJECT = QsClassifierType.newLiteral("sqlQuerySubject");



	constructor(v) {
		super(v);
		this.enumValue = v;
	}

	static fromValue(v) {
		for (var i = 0; (i < QsClassifierType.values().length); ++i) {
			if (QsClassifierType.values()[i].enumValue == v) {
				return QsClassifierType.values()[i];
			}
		}
		throw new Error(v);
	}

	value() {
		return this.enumValue;
	}

	getResourceId() {
		return (("QsClassifierType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/QsClassifierType.js